import { createAnalyticsGroup } from 'js/lib/analytics'

const ediListingCard = document.querySelectorAll('.js-c-promo__listing-card--edi')

if (ediListingCard.length > 0) {
  const track = createAnalyticsGroup('edi--listing-card')
  const currentPage = window.location.href

  ediListingCard.forEach(card => {
    const links = card.querySelectorAll('a')
    links.forEach(link => {
      link.addEventListener('click', () => {
        track('click', `EDI logo from ${currentPage}`)
      })
    })
  })
}
